import React, { useRef, useEffect, useState } from 'react'
import useHttp from '../../../hooks/use-http';
import Input from "../../UI/Input";
import { endPoints } from "../../../config/end-points"
import { cuteToast } from '../../UI/cute';
import { useDispatch, useSelector } from 'react-redux';
import { settingAction } from "../../../store/setting-store";
import Select from 'react-select';
import { all_access } from '../../../config/all_access.config';

const CreateAccess = () => {

    const accessNameRef = useRef();
    const access_codeRef = useRef();
    const subdomain_nameRef = useRef();

    const {sendRequest: insertAccessDetails} = useHttp();
    const {sendRequest: fetchAccess} = useHttp();
    const {sendRequest: deleteAccess} = useHttp();
    const dispatch = useDispatch();
    const subdomain_list = useSelector((state) => state.settings.subdomain_list);
    // const [select_option, setSelect_option ] = useState("");


    const [details, setDetails] = useState({
        id: "",
        accessName: "",
        access_code: "",
        subdomain_name: ""
    });

    const [allaccess, setAllAccess] = useState({});
    const [subaccess, setSubAccess] = useState({});

    const [subdomain_class, setSubdomain_class] = useState("form-control");
    const [access_codeClass, setAccess_codeClass] = useState("mb-4");


    const refersh_subaccess = (p_name,accessAll) => {
        // console.log(details.subdomain_name)
        if(accessAll !== undefined){
            setSubAccess(accessAll.filter(element => element.product_name === p_name));
        }else{
            setSubAccess(allaccess.filter(element => element.product_name === p_name));
        }
    }

    useEffect(()=>{
        // console.log('Access setting page loaded')
        getAllAccess();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const getAllAccess = async () => {
        await fetchAccess({
            url: endPoints.fetchAccess,
            method: "GET",
        },async (response)=>{
            // console.log(response)
            if(response.status === 200 && response.body.length > 0){
                // console.log(response.body)
                const result = response.body
                if(result){
                    setAllAccess(result)
                    dispatch(settingAction.setAccessDetails({ all_access_details:result}));
                    console.log(details);
                    if(details.subdomain_name !== "")
                    {
                        // console.log(details.subdomain_name)
                        refersh_subaccess(details.subdomain_name,result);
                    }
                    
                }
            }
        })
        
        
    }

    const handleCodeChange = (e) =>{
        // console.log(e.value)
        setDetails({ ...details, access_code: e.value })
    }
    
    const handleSubdomainChange = async (event) => {
        const { value } = event.target;
        // console.log(value)
        if(value === ""){
            setSubAccess({});
            setDetails({});
            return;
        }

        setDetails({ ...details, 
            subdomain_name: value,
            accessName: "",
            id: "" 
        });

        // console.log(details);
        refersh_subaccess(value);
        // setSubAccess(allaccess.filter(element => element.product_name === value));
        // await getAllAccess(value);
    };

    const handleAccessChange = (event) => {

        const { value } = event.target; 
        const access_detail = subaccess.find(element => element.access_name === value);
       console.log(access_detail)
        if(access_detail){
            setDetails({  ...details,
                id: access_detail.id,
                accessName: access_detail.access_name,
                access_code: access_detail.access_code
            });
        }else{
            setDetails({  ...details,
                accessName: "",
                id: "",
                access_code: ""
            });
        }

       
    };

    const removeAccess = async () => {

        const access_id = details.id;
        // console.log(access_id)

        await deleteAccess({
            url: endPoints.deleteAccess,
            method: "POST",
            body: { access_id },
        },async (response)=>{
            if(response.status === 200){
                cuteToast({
                    type: "error",
                    message: "Access Removed Successfully.",
                    timer: 5000,
                    title: "Access",
                  });

                setDetails({ ...details, id: '',accessName: '', access_code: '' })
                getAllAccess();
            }
        })

    }


    const formHandler = async (event) => {
        event.preventDefault();
        if( details.subdomain_name === "" || details.subdomain_name === undefined ){
            setSubdomain_class("form-control invalid")
            subdomain_nameRef.current.focus();
            return false;
          }else{
            setSubdomain_class("form-control")
        }

        if( details.accessName === "" ){
            accessNameRef.current.addClassName("form-control invalid")
            accessNameRef.current.focus();
            return false;
          }else{
            accessNameRef.current.addClassName("form-control");
          }
        
          if( details.access_code === "" ){
            setAccess_codeClass("mb-4 invalid_code")
            access_codeRef.current.focus();
            return false;
          }else{
            setAccess_codeClass("mb-4")
          }
        


        await insertAccessDetails({
            url: endPoints.insertAccess,
            method: "POST",
            body: {
                ...details
            },
        },(response)=>{
            if(response.status === 200){
                cuteToast({
                    type: "success",
                    message: "Saved Successfully.",
                    timer: 5000,
                    title: "Access",
                  });

                if(details.id === ""){
                    setDetails({ ...details, accessName: '', access_code: '' })
                }
                getAllAccess();
            }
        })
        
    }
    
  return (
    <div className="col-md-12 mb-4">
        <div className="bx_a">
            <form onSubmit={formHandler}>
                <h5 className="mb-4 pb-3 small_title d-flex">
                    Create Access
                </h5>
                
                <div className="form-row row">
                    <div className="form-group col-md-6">
                        <label htmlFor="inputName" className='h6'>Subdomain List *:</label>
                        <select
                            type="text"
                            className={subdomain_class}
                            onChange={handleSubdomainChange}
                            ref={subdomain_nameRef}
                        >
                            <option value="">Select Subdomain</option>
                            {subdomain_list && subdomain_list.length > 0 && subdomain_list.map((item, index) => {

                                return (
                                    <option key={index} value={item.subdomain_name}>{item.subdomain_name}</option>
                                )
                            })
                            }

                        </select>
                    </div>
                    
                </div>
                <div className='form-row row'>
                <div className="form-group col-md-6">
                        <label htmlFor="inputName" className='h6'>Access List *:</label>
                        {/* <i className="fa fa-trash text-danger"></i> &#xf2db;  */}
                        <select
                            type="text"
                            className="form-control"
                            onChange={handleAccessChange}
                        >
                            <option value="">Select Access</option>
                            {subaccess && subaccess.length > 0 && subaccess.map((item, index) => {

                                return (
                                    <option key={index} value={item.access_name}>{item.access_name} 
                                    </option>
                                )
                            })
                            }

                        </select>
                    </div>
                    { details.id &&  <div className="form-group col-md-6">
                         
                        <div className=" d-flex justify-content-end">
                            <button onClick={ removeAccess } className='btn btn-danger mt-4 w-100' type='button'>Remove Access</button>
                        </div>
                    </div> }
                </div>
                <div className="form-row row">
                    <div className="form-group col-md-6">
                        <label htmlFor="inputName" className='h6'>Access Name *:</label>
                        <Input
                            type="text"
                            inputClass="form-control"
                            value={details.accessName}
                            id="inputName"
                            placeholder="Enter Your Name..."
                            ref={accessNameRef}
                            onChange={(e) =>
                                setDetails({ ...details, accessName: e.target.value })
                            }
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="inputName" className='h6'>Select Access Code:</label>
                        <Select 
                                    options={all_access} 
                                    onChange={handleCodeChange}
                                    ref={access_codeRef}
                                    value={all_access.filter( (option) =>  option.value ===  details.access_code )}
                                    className={access_codeClass}
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <div className="form-group d-flex justify-content-end">
                            <button className='btn mt-4 w-100' type='submit'>Save Details</button>
                        </div> 
                    </div>  
                    
                </div>

                 
            </form>
        </div>
    </div>
  )
}

export default CreateAccess